module.exports = __webpack_public_path__ + "media/bootstrap-icons/textarea-28bfad8f.svg";